import React from 'react';
import { Alert, Stack, Typography } from '@mui/material';

const CompletedAllTradesPanel: React.FC = () => {
  return (
    <Alert
      severity="success"
      sx={{
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: '#2e7d32',
        '& .MuiAlert-message': { width: '100%' }
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
          You've completed all of your trades for this event.
        </Typography>
        <Typography variant="body2">
          You're all set - you can close this page or return to the event.
        </Typography>
      </Stack>
    </Alert>
  );
};

export default CompletedAllTradesPanel;
